// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import ReactSelect, { components } from 'react-select'
import { OrtSelectComponents, OrtSelectStyles } from './Select'
import { linkColor } from './colors'
import Matcher from './SelectWithMatcher/Matcher'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  width: 480px;
`
const AddByLink: StyledComponent<Object, any, any> = styled.a`
  line-height: 14px;
  padding: 2px 10px;
  border: solid 1px ${linkColor};
  borderradius: 2px;
`

const multiValueLabel = () => {
  return {
    ...(OrtSelectStyles.multiValueLabel: Object),
    padding: 0
  }
}

type Props = {
  className?: string,
  matcherClassName: string,
  values: Array<Object>,
  options: Array<Object>,
  isLoading: boolean,
  defaultOptions?: boolean,
  matcherMaxElementsCount: number,
  matcherPlaceholder: string,
  matcherRequestPath: string,
  matcherSubtitle: string,
  matcherTitle: string,
  buildUniqOptions: (Array<Object>, Array<string>) => Array<Object>,
  matchElements: (Array<Object>, Array<string>) => Array<Object>,
  onBeforeComponentValuesChange?: (Array<Object>) => void,
  onComponentValuesChange: (Array<Object>) => void,
  onFocus?: () => void,
  onInputChange: (string) => void,
  onParseFromMatcherInput: (string) => Array<string>,
  optionRenderer: (Object) => any
}

type State = {
  values: Array<Object>,
  isMatcherOpen: boolean
}

const t = {
  add_values: 'Загрузить',
  no_results: 'Ничего не найдено',
  searching: 'Идёт поиск...'
}

export default class SelectWithMatcher extends Component<Props, State> {
  MultiValue: any
  Option: any
  MultiValueRemove: any
  specialString: string

  constructor(props: Props) {
    super(props)
    this.state = { values: props.values, isMatcherOpen: false }
    this.specialString = 'addBy'
    this.MultiValue = (selectProps: Object) => {
      if (selectProps.data.value === this.specialString) return this.addByRenderer()
      return (
        <components.MultiValue {..._.omit(selectProps, 'children')}>
          {props.optionRenderer(selectProps.data)}
        </components.MultiValue>
      )
    }

    this.Option = (selectProps: Object) => {
      return (
        <OrtSelectComponents.Option {..._.omit(selectProps, 'children')}>
          {props.optionRenderer(selectProps.data)}
        </OrtSelectComponents.Option>
      )
    }

    this.MultiValueRemove = ({ children, ...selectProps }: Object) => {
      if (selectProps.data.value === this.specialString) return null
      return <components.MultiValueRemove {...selectProps}>{children}</components.MultiValueRemove>
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!_.isEqual(this.props.values, prevProps.values)) {
      this.setState({ values: this.addSpecialValue(this.props.values) })
    }
  }

  render() {
    return (
      <Wrapper>
        <ReactSelect
          className={this.props.className}
          closeMenuOnSelect={false}
          noOptionsMessage={() => t.no_results}
          loadingMessage={() => t.searching}
          isClearable
          backspaceRemoves={false}
          searchable
          filterOption={this.filterOption}
          openOnFocus
          onFocus={() => {
            this.setState({ values: this.addSpecialValue(this.state.values) })
            this.props.onFocus && this.props.onFocus()
          }}
          onBlur={() => this.onBlur()}
          placeholder=""
          searchPromptText=""
          onCloseResetsInput={false}
          value={this.state.values}
          isMulti
          options={this.props.options}
          onInputChange={(q) => this.props.onInputChange(q)}
          isLoading={this.props.isLoading}
          styles={{ ...OrtSelectStyles, multiValueLabel }}
          components={_.pickBy(
            {
              ...OrtSelectComponents,
              MultiValue: this.MultiValue,
              Option: this.props.defaultOptions ? OrtSelectComponents.Option : this.Option,
              MultiValueRemove: this.MultiValueRemove,
              DropdownIndicator: () => null
            },
            _.identity
          )}
          onChange={(values) => {
            this.props.onComponentValuesChange(this.removeSpecialValue(values))
            this.setState({ values })
          }}
          requireConfirmOnClearAll
        />
        <Matcher
          className={this.props.matcherClassName}
          isOpen={this.state.isMatcherOpen}
          maxElementsCount={this.props.matcherMaxElementsCount}
          placeholder={this.props.matcherPlaceholder}
          requestPath={this.props.matcherRequestPath}
          subtitle={this.props.matcherSubtitle}
          title={this.props.matcherTitle}
          matchElements={(found, fromInput) => this.props.matchElements(found, fromInput)}
          onClose={() => this.setState({ isMatcherOpen: false })}
          onParseFromInput={(input) => this.props.onParseFromMatcherInput(input)}
          onSelect={(matchedValues) => {
            const uniqOptions = this.props.buildUniqOptions(matchedValues, this.state.values)
            const values = this.removeSpecialValue(_.concat(this.state.values, uniqOptions))
            this.props.onBeforeComponentValuesChange &&
              this.props.onBeforeComponentValuesChange(values)
            this.props.onComponentValuesChange(values)
          }}
        />
      </Wrapper>
    )
  }

  onBlur() {
    this.setState({ values: this.removeSpecialValue(this.state.values) })
  }

  addSpecialValue(values: Array<Object>): Array<Object> {
    return _.concat(this.removeSpecialValue(values), this.specialValue())
  }

  removeSpecialValue(values: Array<Object>): Array<Object> {
    return _.reject(values, { value: this.specialString })
  }

  specialValue() {
    return { value: this.specialString, clearableValue: false }
  }

  filterOption() {
    return true
  }

  addByRenderer() {
    return (
      <AddByLink
        className="t-AddByLink"
        onClick={() => this.setState({ isMatcherOpen: true })}
        href="#"
      >
        {t.add_values}
      </AddByLink>
    )
  }
}
